// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"820cf6f0","131":"1e6fe9e8","286":"74a3fe4a","287":"48bb6df2","418":"3aacd045","680":"cfe5ef3e","691":"b9a7cca3"}[chunkId] + ".chunk.css";
};